'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><rect width={20} height={20} x={2} y={2} stroke="currentColor" strokeWidth={2} rx={10} /><path stroke="currentColor" strokeWidth={2} d="M12 15c0-1 0-2 1-2.5s2-1.435 2-2.717S14 7 12 7s-3 1.217-3 3" /><circle cx={12} cy={17} r={0.5} stroke="currentColor" /></svg>;
const IconCircleQuestion = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconCircleQuestion;